import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@components/ui/accordion";
import { Checkbox } from "@components/ui/checkbox";
import { Label } from "@components/ui/label";
import { SingleValueFilterOption } from "@lib/utils/types/filters";
import { OnSelect } from "@lib/utils/types/filters/OnSelect";
import { ToggleAll } from "@lib/utils/types/filters/ToggleAll";
import { CheckedState } from "@radix-ui/react-checkbox";
import { useTransition } from "react";

export interface INestedMultiSelect {
  id: string;
  name: string;
  label: string;
  value: Array<SingleValueFilterOption>;
  selectedValues: string[];
  onSelect: (v: OnSelect) => void;
  toggleAll: (v: ToggleAll) => void;
  indicator: string;
}

export function NestedMultiSelect({
  id,
  label,
  value,
  selectedValues,
  onSelect,
  toggleAll,
  indicator,
}: INestedMultiSelect) {
  const [_, startTransition] = useTransition();
  function onCheckedChange(e: CheckedState) {
    startTransition(() => {
      if (e) {
        toggleAll({
          name: value[0].name,
          value: value.map(v => v.value),
          type: "add",
        });
      } else {
        toggleAll({
          name: value[0].name,
          value: value.map(v => v.value),
          type: "remove",
        });
      }
    });
  }

  function mainState() {
    if (
      selectedValues.every(v => value.map(({ value }) => value).indexOf(v) < 0)
    )
      return false;
    if (
      value.map(({ value }) => value).every(v => selectedValues.indexOf(v) > -1)
    )
      return true;
    return "indeterminate";
  }
  return (
    <AccordionItem value={id} className="w-full border-none ">
      <div className="felx-row flex items-center gap-2">
        <Checkbox
          id={id}
          onCheckedChange={onCheckedChange}
          checked={mainState()}
          aria-label="Toggle all"
        />
        <AccordionTrigger className="w-full">
          <span className="flex items-center gap-2">
            {label} ({value.length} {indicator})
          </span>
        </AccordionTrigger>
      </div>
      <AccordionContent className="flex flex-col space-y-3 border-y border-y-[#AAAAAA] pt-3">
        {value.map(({ value, id, name, label }) => (
          <div className="flex items-center space-x-2" key={value}>
            <Checkbox
              id={value}
              onCheckedChange={_e => {
                onSelect({
                  name: name,
                  type: "multiple",
                  value: value,
                });
              }}
              checked={selectedValues.indexOf(value) > -1}
            />
            <Label htmlFor={id}>{label}</Label>
          </div>
        ))}
      </AccordionContent>
    </AccordionItem>
  );
}
